import { GridItem } from '@cad-arc';
import { EditUnitFormType, EditUnitOptions } from '@mark43/cad-api';
import React from 'react';
import { Control, useWatch } from 'react-hook-form';
import { globalAttributes } from '../../common/global-attributes';
import { FormSelect } from '../../forms/integrated-form-controls/form-select';

export function StationAndBeatFields({
    formFieldOptions,
    beatSubdivisionLabel,
    control,
}: {
    formFieldOptions: EditUnitOptions;
    beatSubdivisionLabel: string;
    control: Control<EditUnitFormType>;
}): React.ReactElement {
    const callSign = useWatch({
        control,
        name: 'callSign',
    });

    if (!callSign) {
        return <></>;
    }
    return (
        <>
            {callSign.unitClass !== globalAttributes.agencyTypeGlobal.POLICE ? (
                <GridItem colSpan={2}>
                    <FormSelect
                        name="station"
                        label="Station"
                        control={control}
                        options={formFieldOptions.stationOptions}
                    />
                </GridItem>
            ) : undefined}
            {callSign.unitClass === globalAttributes.agencyTypeGlobal.POLICE &&
            formFieldOptions.beatSubdivisionOptions.length ? (
                <GridItem colSpan={2}>
                    <FormSelect
                        name="beatSubdivision"
                        label={beatSubdivisionLabel}
                        control={control}
                        options={formFieldOptions.beatSubdivisionOptions}
                    />
                </GridItem>
            ) : undefined}
        </>
    );
}
